import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store} from './store'
import VueI18n from 'vue-i18n'
import VueTippy from 'vue-tippy/dist/vue-tippy.esm';
import PortalVue from 'portal-vue';
import './assets/styles/index.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueHighlightJS from 'vue-highlight.js';
import {JobillaDesignSystem} from "@/jds";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

Vue.use(JobillaDesignSystem)
Vue.use(VueI18n)

Vue.config.productionTip = false

import 'vue-highlight.js/lib/allLanguages'
import 'highlight.js/styles/github.css';
import "wicg-inert";

Vue.use(VueTippy);
Vue.use(PortalVue)
Vue.use(VueHighlightJS);

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

const i18n = new VueI18n({
  locale: 'en-US',
  messages: {
    'en-US': {
      'jds': {
        'general':  require('./design-system/text/general.text.json'),
        'components':  require('./design-system/text/components.text.json'),
        'constructs':  require('./design-system/text/constructs.text.json'),
        'forms':  require('./design-system/text/forms.text.json'),
        'patterns':  require('./design-system/text/patterns.text.json'),
      },
    }
  }
})



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
